module.exports = __webpack_public_path__ + "img/bg1.a7baa0c4.png";